<template>
  <component
    :is="tag"
    class="ds-alert"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'DsAlert',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "../../assets/stylus/variables.styl"

.ds-alert {
  display: flex;
  padding: 7px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 1px;
  background: $nx-accent-100;
}
</style>
